import { cn } from "@veil/ui/lib/utils";
import { useMemo } from "react";

export function DiffView({ diff }: { diff: string }) {
	const lines = useMemo(() => {
		// Pre-compute a stable key per line so React doesn't reuse the wrong
		// DOM node when diffs change shape between renders.
		return diff.split("\n").map((line, i) => ({
			key: `${i}:${line.slice(0, 32)}`,
			tag: line[0],
			rest: line.slice(1),
			lineNo: i + 1,
		}));
	}, [diff]);
	return (
		<div className="overflow-hidden rounded-lg border border-zinc-800/90 ring-1 ring-zinc-950/80">
			<pre className="max-h-[min(58vh,38rem)] overflow-auto bg-zinc-950 p-4 font-mono text-[0.8125rem] leading-relaxed text-zinc-100 [scrollbar-gutter:stable]">
				{lines.map(({ key, tag, rest, lineNo }) => {
					const cls =
						tag === "+"
							? "bg-emerald-500/15 text-emerald-300"
							: tag === "-"
								? "bg-red-500/15 text-red-300"
								: "text-zinc-400";
					const sigil = tag === "+" ? "+" : tag === "-" ? "-" : " ";
					return (
						<div
							key={key}
							className={cn(
								"flex min-w-0 gap-3 px-3 py-0.5 first:pt-1 last:pb-1",
								cls,
							)}
						>
							<span className="w-10 shrink-0 select-none tabular-nums text-zinc-500">
								{String(lineNo).padStart(4, " ")}
							</span>
							<span className="shrink-0 select-none">{sigil}</span>
							<span className="min-w-0 flex-1 whitespace-pre-wrap break-words">
								{rest}
							</span>
						</div>
					);
				})}
			</pre>
		</div>
	);
}
